<template>
  <div class="game-container">
    <img src="./stop.png" />
  </div>
</template>
<script>
import defaultMixins from '../../mixins/defaultMixin';

export default {
  name: 'mp-error',
  mixins: [defaultMixins],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  beforeDestroy() {},
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped></style>
